import type { TopicExercises } from "~/features/computer/data/exercises/exercise.types";

export const legalEthicsExercises: TopicExercises = {
  mcqs: [
    {
      id: "le1",
      difficulty: "easy",
      topic: "security-threats",
      anchor: "phishing",
      question: "Agar fake email aap se password mange to yeh kis threat ka example hai?",
      options: ["Phishing", "Spyware", "Spam", "Bias"],
      correctIndex: 0,
      explanation: "Phishing me fake message ya email ke through user se sensitive info li jati hai.",
    },
    {
      id: "le2",
      difficulty: "medium",
      topic: "security-threats",
      anchor: "pharming",
      question: "User sahi website type kare lekin fake website par chala jaye. Isay kya kehte hain?",
      options: ["Phishing", "Pharming", "Spyware", "Spam"],
      correctIndex: 1,
      explanation: "Pharming user ko redirect karke fake site par le jata hai, chahe address sahi type kiya ho.",
    },
    {
      id: "le3",
      difficulty: "easy",
      topic: "digital-divide",
      anchor: "access-gap",
      question: "Digital divide ka basic matlab kya hai?",
      options: ["Internet speed barhana", "Technology access gap", "Online shopping", "Software update"],
      correctIndex: 1,
      explanation: "Digital divide se murad un logon ka farq hai jin ke paas technology access hai aur jin ke paas nahi.",
    },
    {
      id: "le4",
      difficulty: "easy",
      topic: "terms",
      anchor: "terms-of-use",
      question: "Terms of Use aam tor par kis cheez ko explain karte hain?",
      options: ["App ka color", "Service use karne ke rules", "Computer speed", "Exam dates"],
      correctIndex: 1,
      explanation: "Terms of Use user ko batate hain ke service ko kin rules ke sath use kiya ja sakta hai.",
    },
    {
      id: "le5",
      difficulty: "medium",
      topic: "digital-citizenship",
      anchor: "responsible-behavior",
      question: "Responsible digital behavior ka best example kya hai?",
      options: ["Fake news share karna", "Password public karna", "Source verify karna", "Har link open karna"],
      correctIndex: 2,
      explanation: "Responsible user information verify karta hai aur safe behavior adopt karta hai.",
    },
    {
      id: "le6",
      difficulty: "medium",
      topic: "terms",
      anchor: "privacy-policy",
      question: "Privacy policy ka main purpose kya hota hai?",
      options: ["Design explain karna", "Data collect aur use ka tareeqa batana", "Game rules batana", "Network setup karna"],
      correctIndex: 1,
      explanation: "Privacy policy explain karti hai ke app ya website user ka data kaise collect aur use karegi.",
    },
    {
      id: "le7",
      difficulty: "hard",
      topic: "bias",
      anchor: "algorithm-bias",
      question: "Algorithm bias ka simple effect kya ho sakta hai?",
      options: ["Har user ko equal result", "Kuch logon ke liye unfair result", "Faster internet", "Extra storage"],
      correctIndex: 1,
      explanation: "Biased algorithm kuch groups ko unfair ya inaccurate result de sakta hai.",
    },
    {
      id: "le8",
      difficulty: "easy",
      topic: "security-threats",
      anchor: "spam",
      question: "Spam se kya murad hoti hai?",
      options: ["Useful official email", "Unwanted messages", "Secure software", "Terms document"],
      correctIndex: 1,
      explanation: "Spam unwanted ya irrelevant messages hotay hain jo user ko disturb karte hain.",
    },
  ],
  short: [
    {
      id: "le-short-1",
      question: "Terms of use important kyun hote hain?",
      answer: "Terms of use user ko rules batate hain taake wo service ko sahi aur safe tareeqe se use kare.",
    },
    {
      id: "le-short-2",
      question: "Digital divide ka education par kya effect hota hai?",
      answer: "Jin students ke paas devices ya internet nahi hota un ki learning opportunities kam ho jati hain.",
    },
    {
      id: "le-short-3",
      question: "Safe data usage ka aik simple rule batao.",
      answer: "Personal data sirf trusted platform par share karo aur har random link par click na karo.",
    },
  ],
  long: [
    {
      id: "le-long-1",
      question: "Terms of use ke common clauses explain karo.",
      solution: "Terms of use aam tor par rules, allowed behavior aur platform ki responsibility limits ko explain karte hain. FSC level par bas itna yaad rakho ke user ko service use karne se pehle in rules ko samajhna chahiye.",
      steps: [
        "Terms of use service ke rules batate hain.",
        "Privacy policy data handling ko explain karti hai.",
        "Liability clause batata hai ke company kis had tak zimmedar hai.",
      ],
    },
    {
      id: "le-long-2",
      question: "Digital divide ko explain karo.",
      solution: "Digital divide technology access ka farq hai. Kuch logon ke paas internet, devices aur digital skills hoti hain jab ke kuch log is se mehroom rehte hain. Is ka direct asar education aur opportunities par padta hai.",
      steps: [
        "Technology access har jagah equal nahi hota.",
        "Devices aur internet na hone se learning slow ho sakti hai.",
        "Digital divide social aur educational gap ko barha sakta hai.",
      ],
    },
    {
      id: "le-long-3",
      question: "Digital collaboration aur responsible behavior ki importance explain karo.",
      solution: "Online collaboration tabhi effective hoti hai jab users responsible behavior adopt karein. Respectful communication, source verification aur safe sharing se digital environment better hota hai.",
      steps: [
        "Team work me respectful behavior zaroori hota hai.",
        "Fake information share karna trust ko damage karta hai.",
        "Safe internet use collaboration ko secure banata hai.",
      ],
    },
  ],
};
